import { JWT } from '../interfaces';
import { LoginSession } from '../../domain';
import { getJWTPayload } from '../payload';

export interface JWTPayload {
    readonly user_id: string;
    readonly platform_id: string;

    /** Not valid before timestamp. */
    readonly nbf: number;

    /** Expiration timestamp. */
    readonly exp: number;

    /** Issued at timestamp. */
    readonly iat: number;

    /** Issuer. */
    readonly iss: string;
}

export class LoginSessionJWT implements LoginSession {
    private readonly jwtPayload: JWTPayload;

    public constructor(readonly jwt: JWT) {
        this.jwtPayload = getJWTPayload<JWTPayload>(jwt, ['user_id', 'platform_id', 'nbf', 'exp', 'iat', 'iss']);
    }

    /**
     * Return JWT as is.
     */
    public getToken() {
        return this.jwt;
    }

    /**
     * Check if session isn't expired and is used in a valid period of time.
     * This doesn't guarantee the validity of session token since it may be **modified** by an attacker.
     */
    public isActual() {
        /** Current timestamp in seconds. */
        const now = Date.now() / 1000;
        // return now < this.jwtPayload.exp && now >= this.jwtPayload.nbf;
        const delta = 5 * 60; // 5 minutes
        return now < this.jwtPayload.exp + delta && now >= this.jwtPayload.nbf - delta;
    }

    /**
     * Check if session needs a refresh.
     */
    public isRefreshRequired() {
        throw new Error('Method is not implemented');
    }
}
